import { Controller } from "@hotwired/stimulus"
import Tags from "../components/Tags.svelte";

export default class extends Controller {
  connect() {
    const target = this.element;
    new Tags({
      target: target,
      props: {
        name: "tags[]",
        className: "form-control",
        tags: JSON.parse(target.dataset.tags),
        autoComplete: JSON.parse(target.dataset.availableTags),
        onlyAutocomplete: true,
        addKeys: [188]
      }
    })

  }

  disconnect() {
    this.element.innerHTML = "";
  }
}
